export const SvgRightArrow = (props: any) => {
	return (
		<svg
			width="9"
			height="13"
			viewBox="0 0 9 13"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M8.20528 6.50004C8.20528 6.73302 8.11633 6.96598 7.93878 7.14361L2.34902 12.7333C1.99344 13.0889 1.41693 13.0889 1.0615 12.7333C0.706063 12.3779 0.706063 11.8015 1.0615 11.4459L6.00763 6.50004L1.06167 1.55417C0.706236 1.19859 0.706236 0.622254 1.06167 0.266848C1.4171 -0.0889026 1.99361 -0.0889026 2.34919 0.266848L7.93895 5.85646C8.11653 6.03418 8.20528 6.26714 8.20528 6.50004Z"
				fill={props.color ? props.color : "#333333"}
			/>
		</svg>
	);
};
